import { createContext, useState, useCallback } from "react";

const GlobalContext = createContext({});

const GlobalProvider = ({ children, fbService }) => {
  const [firebaseService] = useState(fbService);
  const [mobileView, setMobileView] = useState(false);
  const [tabletView, setTabletView] = useState(false);
  const [desktopView, setDesktopView] = useState(false);
  const [largeView, setLargeView] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [userProfile, setUserProfile] = useState({});
  const [docs, setDocs] = useState(null);

  const setView = useCallback(
    (mobile, tablet, large) => {
      setMobileView(mobile);
      setTabletView(tablet);
      setLargeView(large);
      setDesktopView(!mobileView && !tabletView && !largeView);
    },
    [mobileView, tabletView, largeView],
  );

  return (
    <GlobalContext.Provider
      value={{
        firebaseService,
        mobileView,
        tabletView,
        largeView,
        desktopView,
        setView,
        setAuthError,
        authError,
        userProfile,
        setUserProfile,
        docs,
        setDocs,
      }}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContext;
export { GlobalProvider };
